import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DocumentsTab } from '@/app/(client)/network/-components/companyProfileTabs/documents/DocumentsTab';
import { useCompanyDetail } from '@/app/(client)/network/-hooks/useCompanyDetail';
import { useSessionStore } from '@/store/sessionStore';

const searchSchema = z.object({
  page: z.number().int().min(1).optional(),
  limit: z.number().int().min(10).max(500).optional(),
  sort: z.string().optional(),
  filters: z.record(z.string(), z.array(z.string())).optional(),
  dialog: z.enum(['create-document']).optional().catch(undefined),
});

export const Route = createFileRoute(
  '/(client)/network/(pages)/(detail)/$companyId/documents',
)({
  validateSearch: searchSchema,
  component: DocumentsRoute,
});

function DocumentsRoute() {
  const { companyId } = Route.useParams();
  const { data: company } = useCompanyDetail(companyId);
  const user = useSessionStore(s => s.user);
  const isOwnCompany = user?.companyId === (company?.forCompanyId ?? companyId);
  const companyName =
    (company?.data?.display_name?.value as string | undefined) ??
    (company?.data?.official_name?.value as string | undefined);
  return (
    <DocumentsTab
      companyId={companyId}
      isOwnCompany={isOwnCompany}
      {...(companyName !== undefined ? { companyName } : {})}
    />
  );
}
